import React from 'react';
import { connect } from 'react-redux';
import { AUTH_TYPE } from 'utils/auth';
import LoginIdEntry from './LoginIdEntry';
import MokaAuth from './MokaAuth';
import GoAuth from './GoAuth';
import GoId from './GoId';
import {
  checkAuthType,
  resetLogin,
  authenticateGoAuth,
  authenticateMoka,
} from '../../state/login/actions';
import { replaceView } from '../../state/openPlatform/actions';
import { MOKA_OPEN_API_HOST } from '../../api/constants';

function prepareLoginPayload(loginId) {
  // FIXME This is the old logic. Perserving to avoid behaviour change.
  let trimEmail = loginId.trim();
  if (!isNaN(loginId)) {
    if (trimEmail[0] === '0') {
      trimEmail = trimEmail.slice(1);
    } else if (trimEmail[0] === '+') {
      trimEmail = trimEmail.slice(3);
    }
  }

  const payload = isNaN(trimEmail)
    ? { email: trimEmail }
    : { phone: `+62${trimEmail}` };

  return payload;
}

class Login extends React.Component {
  state = {
    loginId: '',
  };

  componentWillMount() {
    const { location } = this.props;
    const next = location?.query?.next;
    if (next && next?.startsWith(MOKA_OPEN_API_HOST)) {
      this.props.replaceView({ next });
    }
  }

  componentWillUnmount() {
    this.props.resetLogin();
  }

  handleIdEntryChange = loginId => {
    this.setState({
      loginId,
    });
  };

  handleIdEntrySubmit = () => {
    const { checkAuthType } = this.props;
    const { loginId } = this.state;
    const { email, phone } = prepareLoginPayload(loginId);

    checkAuthType(email, phone);
  };

  handleLogin = password => {
    const { authenticateMoka, location } = this.props;
    const { loginId } = this.state;
    const { email, phone } = prepareLoginPayload(loginId);
    const nextUrl = location.query.next;

    authenticateMoka(email, phone, password, nextUrl);
  };

  handleGoAuthLogin = password => {
    const { authenticateGoAuth, location } = this.props;
    const { loginId } = this.state;
    const nextUrl = location.query.next;
    authenticateGoAuth(loginId, password, nextUrl);
  };

  handleGoIdLogin = password => {
    // eslint-disable-next-line no-alert
    alert(`Got ${password}. Actual login not yet implemented`);
  };

  handleReset = () => {
    this.props.resetLogin();
    this.setState({
      loginId: '',
    });
  };

  render() {
    const { authType, appName } = this.props;
    const { loginId } = this.state;
    let node = null;

    if (!loginId || !authType) {
      node = (
        <LoginIdEntry
          loginId={loginId}
          onChange={this.handleIdEntryChange}
          onNext={this.handleIdEntrySubmit}
          appName={appName}
        />
      );
    } else if (authType === AUTH_TYPE.MOKA) {
      node = (
        <MokaAuth
          loginId={loginId}
          onNext={this.handleLogin}
          onReset={this.handleReset}
          appName={appName}
        />
      );
    } else if (authType === AUTH_TYPE.GO_AUTH) {
      node = (
        <GoAuth
          loginId={loginId}
          onNext={this.handleGoAuthLogin}
          onReset={this.handleReset}
          appName={appName}
        />
      );
    } else if (authType === AUTH_TYPE.GO_ID) {
      node = (
        <GoId
          loginId={loginId}
          onNext={this.handleGoIdLogin}
          onReset={this.handleReset}
          appName={appName}
        />
      );
    }

    return node;
  }
}

function mapStateToProps(state) {
  const { authType } = state.login;
  const { app } = state.openPlatform.login;
  return {
    authType,
    appName: app ? app.name : '',
  };
}

const mapDispatchToProps = {
  checkAuthType,
  resetLogin,
  authenticateGoAuth,
  authenticateMoka,
  replaceView,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
